import { HeartHandshake, HandHeart, HandHelping, Star, ClipboardList, CalendarDays, Megaphone } from 'lucide-react';
import OneAct from '../components/Dashboard/Widget/OneAct';
import MyTasks from '../components/Dashboard/MyTasks/MyTasks';
import MySchedule from '../components/Dashboard/MySchedule/MySchedule';
import GivingChart from '../components/Dashboard/GivingChart';
import ResiViewing from '../components/Dashboard/ResiViewing';
import CampaignStatus from '../components/Dashboard/CampaignStatus';
import styles from '../components/Dashboard/Widget/Widget.module.css';
import { 
  Widget, 
  StatCardData, 
  GivingTrendItem, 
  ViewingData, 
  Task, 
  ScheduleEvent, 
  OneActData, 
  CampaignStatusData 
} from '../types';

const oneActData: OneActData = {
  avatar: 'https://placehold.co/48x48/E0E7FF/4F46E5?text=MH',
  name: 'Maria Hernandez',
  description: 'Missed last 5 services and recently stopped giving.',
};

const campaignStatusData: CampaignStatusData = {
  weekly: 7250,
  raised: 67500,
  target: 100000,
};

const prayerRequestContent = (
  <p>A surge in prayer requests for job security and financial provision. <br />&#10024; Consider addressing financial stewardship in sermons (e.g., Matthew 6:25-34) or start a workshop on budgeting and financial planning.</p>
);

export const givingTrendData: GivingTrendItem[] = [
  { name: '8/31', unique: 1490, recurring: 2000 },
  { name: '9/7', unique: 1800, recurring: 2500 },
  { name: '9/14', unique: 1300, recurring: 1800 },
  { name: '9/21', unique: 1700, recurring: 2500 },
  { name: '9/28', unique: 1500, recurring: 2300 },
  { name: '10/5', unique: 1800, recurring: 2700 },
];

export const resiViewingData: ViewingData[] = [
  { name: '8/31', live: 1200, onDemand: 1800 },
  { name: '9/7', live: 1500, onDemand: 2200 },
  { name: '9/14', live: 1100, onDemand: 1600 },
  { name: '9/21', live: 1400, onDemand: 2100 },
  { name: '9/28', live: 1300, onDemand: 1900 },
  { name: '10/5', live: 1600, onDemand: 2400 },
];

export const myTasks: Task[] = [
  {
    id: 'task1',
    title: 'Complete upcoming scheduling',
    description: '4 unfilled volunteer slots for next Sunday\'s connection team.',
    dueDate: '10/19/2025',
  },
  {
    id: 'task2',
    title: 'Review potential duplicate profiles',
    description: 'Two profiles found for "Michael Johnson".',
    dueDate: '10/21/2025',
  }
];

export const mySchedule: ScheduleEvent[] = [
  {
    id: 'event1',
    title: 'Team Prayer',
    location: 'Prayer Room',
    confirmed: 12,
    date: '2025-10-13T09:00:00'
  },
  {
    id: 'event2',
    title: 'Worship Rehearsal',
    location: 'Main Auditorium',
    confirmed: 8,
    date: '2025-10-15T18:30:00'
  }
];

export const initialWidgets: Widget[] = [
  {
    id: 'schedule',
    title: 'My Schedule',
    icon: <CalendarDays />,
    content: <MySchedule events={mySchedule} />,
    footer: <a href="#!">View Schedule →</a>,
  },
  {
    id: 'tasks',
    title: 'My Tasks',
    icon: <ClipboardList />,
    content: <MyTasks tasks={myTasks} />,
    footer: <a href="#!">View All Tasks →</a>,
  },
  {
    id: 'giving',
    title: 'Weekly Giving',
    icon: <HandHeart />,
    content: <GivingChart data={givingTrendData} />,
    footer: <a href="#!">View Giving Report →</a>,
  },
  {
    id: 'resi-viewing',
    title: 'Online Viewing',
    icon: <img src="/resi.svg" alt="Resi logo" className="custom-icon" />,
    content: <ResiViewing data={resiViewingData} />,
    footer: <a href="#!">View Resi Analytics →</a>,
  },
  {
    id: 'one-act',
    title: 'One Act',
    icon: <Star />,
    content: <OneAct data={oneActData} />,
    footer: <a href="#!">Send a check-in message →</a>,
  },
  {
    id: 'campaign-status',
    title: 'Building Fund Campaign',
    icon: <Megaphone />,
    content: <CampaignStatus data={campaignStatusData} />,
    footer: <a href="#!">View Campaign Details →</a>,
  },
  {
    id: 'prayer',
    title: 'Prayer Requests',
    icon: <HandHelping />,
    tag: 'Medium',
    content: prayerRequestContent,
    footer: <a href="#!">View Prayer Requests →</a>,
  },
  {
    id: 'needs',
    title: 'Unmet Needs',
    icon: <HeartHandshake />,
    tag: 'Medium',
    content: <div><p>There are unmet needs for Thursday's outreach program. Can you help? The needs are:</p><ul className={styles.unmetNeedsList}><li>a gas barbecue</li><li>yard games</li></ul></div>,
    footer: <a href="#!">View Needs →</a>,
  }
];

export const statCardData: StatCardData[] = [
  {
    title: "Recent New Attenders",
    value: "12",
    trend: "14.29%",
    change: "-2",
    isPositive: false
  },
  {
    title: "Recent New Donors",
    value: "18",
    trend: "38.46%",
    change: "+5",
    isPositive: true
  },
  {
    title: "YTD Giving",
    value: "$36,700",
    trend: "4.1%",
    isPositive: true
  },
  {
    title: "New Group Participants",
    value: "7",
    trend: "75%",
    change: "+3",
    isPositive: true
  }
];
